import PropTypes from 'prop-types';
import ToggleSwitch from './ToggleSwitch';

function SettingRow({
  icon, label, enabled, onToggle,
}) {
  return (
    <div className="flex items-center justify-between py-3">
      <div className="flex items-center gap-3">
        {icon}
        <span className="text-puzzle-text">{label}</span>
      </div>
      <ToggleSwitch
        enabled={enabled}
        onToggle={onToggle}
        label={`Toggle ${label}`}
      />
    </div>
  );
}

SettingRow.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SettingRow;
